// Copyright (c) 2022 Enabler Interactive Pty Ltd

import React, { Component } from 'react'
import { Col, Button, Row, Modal } from 'react-bootstrap'
import braintree from 'braintree-web'
import { MainSidebar } from '../components/mainsidebar'
import { ModuleItem } from '../components/moduleItem'
import config from '../config/config.json'
import { fixScrollbar } from '../utils/enUtils'

export class WorkerStore extends Component {
    constructor(props) {
        super(props)

        this.state = {
            modules: [],
            tutorialModules: [],
            foundationalModules: [],
            showPurchaseModal: false,
            paymentMethodButtonVisibility: { display: 'block' },
            confirmPaymentButtonVisibility: { display: 'none' },
            purchaseModuleName: "",
            purchaseModuleId: "",
            purchaseModulePrice: 0,
            purchaseModuleQuantity: 1,
            paymentForm: { display: 'block' },
            paymentSuccessful: { display: 'none' },
            showPurchaseFreeModal: false,
        }

        this.path = {
            modules: '/assets/images/Modules/'
        }

        this.clientToken = {
            'staging': 'sandbox_rbgc9495_3tg6fjhbsnv6k26j',
            'production': 'production_kzkyg36z_vbpj52gm2fdwfdgb'
        }

        this.getAllModules(this.props.env, config)


        if (!window.sessionStorage.getItem('authToken')) {
            console.log("not logged in")
            this.props.router.push('/login')
        }

        if (this.props.appData.authToken === '') {
            let storedData = window.sessionStorage

            let data = {
                profileType: storedData.profileType,
                loginStatus: storedData.loginStatus,
                authToken: storedData.authToken,
                average_strikes: storedData.average_strikes,
                confirmed: storedData.confirmed,
                email: storedData.email,
                gender: storedData.gender,
                purpose: storedData.purpose,
                uid: storedData.uid,
                first_name: storedData.first_name,
                last_name: storedData.last_name,
                last_active_at: storedData.last_active_at,
                workers: JSON.parse(storedData.workers),
                globalModules: JSON.parse(storedData.globalModules)
            }

            this.props.handleWorkerDataUpdateFromSessionStorage(data)
        }

        this.buyModule = this.buyModule.bind(this)
        this.prepareModuleItems = this.prepareModuleItems.bind(this)
        this.openPurchaseModal = this.openPurchaseModal.bind(this)
        this.closePurchaseModal = this.closePurchaseModal.bind(this)
        this.purchaseModal = this.purchaseModal.bind(this)
        this.braintreeInit = this.braintreeInit.bind(this)
        this.handlePaymentSelectionButtonClick = this.handlePaymentSelectionButtonClick.bind(this)
        this.updateQuantity = this.updateQuantity.bind(this)
        this.openPurchaseFreeModal = this.openPurchaseFreeModal.bind(this)
        this.closePurchaseFreeModal = this.closePurchaseFreeModal.bind(this)
        this.purchaseFreeModal = this.purchaseFreeModal.bind(this)
        this.handleBuyFreeModule = this.handleBuyFreeModule.bind(this)
    }

    getAllModules(env, config) {
        fetch(config[env] + config.api.all_modules.endpoint, {
            method: config.api.all_modules.type,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        }).then((response) => response.json())
            .then((responseJson) => {
                //filtering out modules with no category
                let modules = responseJson.filter(module => {
                    return module.category != null
                })

                modules.sort((a, b) => (a.name < b.name) ? -1 : 1)
                modules = this.getRelevantModules(modules)

                let tutorialModules = modules.filter(module => {
                    return module.category.includes(config.consts.MOD_TUTORIAL)
                })

                let foundationalModules = modules.filter(module => {
                    return module.category.includes(config.consts.MOD_FOUNDATION)
                })

                this.setState({
                    modules,
                    tutorialModules,
                    foundationalModules
                })

            })
            .catch((error) => {
                console.error(error)
            })
    }

    getRelevantModules(modules, myName = "") {
        return modules.filter(module => {
            return !(module.category.includes("Exclusive"))
        })
    }

    handleBuyFreeModule(e) {
        e.preventDefault()

        this.buyFreeModule(this.props.env, config)
    }

    buyFreeModule(env, config) {
        let jsonPost = JSON.stringify({
            licence: {
                enabler_module_id: this.state.purchaseModuleId,
                user_nonce: null,
                count: 1
            }
        })

        fetch(config[env] + config.api.create_licence.endpoint, {
            method: config.api.create_licence.type,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.props.appData.authToken
            },
            body: jsonPost
        }).then((response) => response.json())
            .then((responseJson) => {
                this.setState({
                    paymentForm: { display: 'none' },
                    paymentSuccessful: { display: 'block' }
                })

            })
            .catch((error) => {
                console.error(error)
            })
    }

    buyModule(env, config, instance) {
        fetch(config[env] + config.api.create_licence.endpoint, {
            method: config.api.create_licence.type,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.props.appData.authToken
            },
            body: JSON.stringify({
                licence: {
                    enabler_module_id: this.state.purchaseModuleId,
                    user_nonce: instance.nonce,
                    count: 1
                }
            })
        }).then((response) => response.json())
            .then((responseJson) => {
                this.setState({
                    paymentForm: { display: 'none' },
                    paymentSuccessful: { display: 'block' }
                })
            })
            .catch((error) => {
                console.error(error)
            })
    }

    evalFreeModule(modulePrice) {
        return (Number(modulePrice) === 0)
    }

    prepareModuleItems() {
        return this.state.modules.map((module, index) => {
            return (
                <ModuleItem
                    key={index}
                    image={module.icon}
                    name={module.name}
                    category={module.category}
                    summary={module.summary}
                >
                    <Row>
                        <Col sm={8}>
                            Price: <span>${Number(module.price).toFixed(2)}</span>
                        </Col>
                        <Col sm={4}>
                            <Button data-index={index} data-moduleName={module.name} data-moduleId={module.id} data-modulePrice={module.price} onClick={this.openPurchaseModal}>Buy</Button>

                        </Col>
                    </Row>
                </ModuleItem>
            )
        })
    }

    prepareTutorialModuleItems() {
        return this.state.tutorialModules.map((module, index) => {
            return (
                <ModuleItem
                    key={index}
                    image={module.icon}
                    name={module.name}
                    category={module.category}
                    summary={module.summary}
                >
                    <Row>
                        <Col sm={8}>
                            <p><span><b>Price: </b></span> {this.evalFreeModule(module.price) ? "Free" : "$" + Number(module.price).toFixed(2)}</p>
                        </Col>
                        <Col sm={4}>
                            <Button bsStyle="primary" data-index={index} data-moduleName={module.name} data-moduleId={module.id} data-modulePrice={module.price} onClick={this.openPurchaseFreeModal}>Add Module</Button>

                        </Col>
                    </Row>
                </ModuleItem>
            )
        })
    }

    prepareFoundationalModuleItems() {
        return this.state.foundationalModules.map((module, index) => {
            return (
                <ModuleItem
                    key={index}
                    image={module.icon}
                    name={module.name}
                    category={module.category}
                    summary={module.summary}
                >
                    <Row>
                        <Col sm={8}>
                            <p><span><b>Price: </b></span> {this.evalFreeModule(module.price) ? "Free" : "$" + Number(module.price).toFixed(2)} </p>
                        </Col>
                        <Col sm={4}>
                            {
                                this.evalFreeModule(module.price) ?
                                    (<Button data-index={index} data-moduleName={module.name} data-moduleId={module.id} data-modulePrice={module.price} onClick={this.openPurchaseFreeModal} bsStyle="primary">Add Module</Button>) :
                                    (<Button data-index={index} data-moduleName={module.name} data-moduleId={module.id} data-modulePrice={module.price} onClick={this.openPurchaseModal} bsStyle="primary">Buy</Button>)
                            }
                        </Col>
                    </Row>
                </ModuleItem>
            )
        })
    }

    openPurchaseModal(e) {
        this.setState({
            showPurchaseModal: true,
            paymentForm: { display: 'block' },
            purchaseModuleName: e.target.getAttribute('data-moduleName'),
            purchaseModuleId: e.target.getAttribute('data-moduleId'),
            purchaseModulePrice: Number(e.target.getAttribute('data-modulePrice')).toFixed(2)
        })
    }

    closePurchaseModal() {
        this.setState({
            showPurchaseModal: false,
            confirmPaymentButtonVisibility: { display: 'none' },
            paymentMethodButtonVisibility: { display: 'block' },
            paymentForm: { display: 'block' },
            paymentSuccessful: { display: 'none' }
        })

        fixScrollbar()
    }

    openPurchaseFreeModal(e) {
        this.setState({
            showPurchaseFreeModal: true,
            paymentForm: { display: 'block' },
            purchaseModuleName: e.target.getAttribute('data-moduleName'),
            purchaseModuleId: e.target.getAttribute('data-moduleId'),
            purchaseModulePrice: Number(e.target.getAttribute('data-modulePrice')).toFixed(2)
        })
    }

    closePurchaseFreeModal() {
        this.setState({
            showPurchaseFreeModal: false,
            confirmPaymentButtonVisibility: { display: 'none' },
            paymentMethodButtonVisibility: { display: 'block' },
            paymentSuccessful: { display: 'none' }
        })

        fixScrollbar()
    }

    purchaseFreeModal() {
        return (
            <Modal show={this.state.showPurchaseFreeModal} onHide={this.closePurchaseFreeModal} onExited={this.closePurchaseFreeModal} bsSize='small'>
                <Modal.Header closeButton>
                    <Modal.Title componentClass="h4">Add Module</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form id="payment-form" method="post" style={this.state.paymentForm}>
                        <div>
                            <label>Module: </label>{this.state.purchaseModuleName}
                        </div>
                        <div>
                            <label>Quantity: </label>
                            <span>1 </span>
                            <input type="hidden" id="modulePurchaseQuantity" onChange={this.updateQuantity} defaultValue={1} disabled />
                        </div>
                        <div><label>Unit Price (incl. GST): </label>Free</div>
                        <Button bsStyle="primary" id="select-payment-button" style={this.state.paymentMethodButtonVisibility} onClick={this.handleBuyFreeModule}>Confirm</Button>
                    </form>
                    <section className="payment-successful" style={this.state.paymentSuccessful}>
                        <h3>Module added successfully!</h3>
                        <div><img src="/assets/images/Icons/check.png" alt="Payment Successful" /></div>
                        <Button bsStyle="primary" onClick={this.closePurchaseFreeModal}>Done</Button>
                    </section>
                </Modal.Body>
            </Modal>
        )
    }

    purchaseModal() {
        let totalPrice = this.state.purchaseModulePrice * this.state.purchaseModuleQuantity

        return (
            <Modal show={this.state.showPurchaseModal} onHide={this.closePurchaseModal} onExited={this.closePurchaseModal} bsSize='small'>
                <Modal.Header closeButton>
                    <Modal.Title componentClass="h4">Buy Module</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <form id="payment-form" method="post" style={this.state.paymentForm}>
                        <div>
                            <label>Module: </label><span>{this.state.purchaseModuleName}</span>
                        </div>
                        <div>
                            <label>Quantity: </label>
                            <span>1 </span>
                            <input type="hidden" id="modulePurchaseQuantity" onChange={this.updateQuantity} defaultValue={1} disabled />
                        </div>
                        <div><label>Unit Price (incl. GST): </label>${this.state.purchaseModulePrice}</div>
                        <div><label>Total Price (incl. GST): </label>${Number(totalPrice).toFixed(2)}</div>

                        <Button bsStyle="primary" id="select-payment-button" style={this.state.paymentMethodButtonVisibility} onClick={this.handlePaymentSelectionButtonClick}>Select Payment Method</Button>

                        <section className="drop-in-section" style={this.state.confirmPaymentButtonVisibility}>
                            <div id="dropin-container"></div>
                            <Button bsStyle="primary" type="submit" id="submit-button" >Confirm Payment</Button>
                        </section>
                    </form>

                    <section className="payment-successful" style={this.state.paymentSuccessful}>
                        <h3>Payment Successful!</h3>
                        <div><img src="/assets/images/Icons/check.png" alt="Payment Successful" /></div>

                        <Button bsStyle="primary" onClick={this.closePurchaseModal}>Done</Button>
                    </section>
                </Modal.Body>
            </Modal>
        )
    }

    updateQuantity(e) {
        if (e.target.value < 0) {
            e.target.value = Math.abs(e.target.value)
        }
        if (e.target.value - Math.floor(e.target.value) > 0) {
            e.target.value = Math.floor(e.target.value)
        }
        this.setState({
            purchaseModuleQuantity: e.target.value
        })
    }

    handlePaymentSelectionButtonClick(e) {
        this.braintreeInit()

        this.setState({
            confirmPaymentButtonVisibility: { display: 'block' },
            paymentMethodButtonVisibility: { display: 'none' },
        })
    }

    braintreeInit() {
        braintree.setup(
            this.clientToken[this.props.env],
            'dropin',
            {
                container: 'dropin-container',
                onPaymentMethodReceived: function (instance) {
                    this.buyModule(this.props.env, config, instance)

                }.bind(this)
            }
        )
    }

    render() {
        return (
            <div className="store-container">
                <MainSidebar
                    profileType={this.props.appData.profileType}
                    logout={this.props.handleLoginStateChange}
                    profile={2}
                    appData={this.props.appData}
                />

                <div className="main-body" style={{ 'marginLeft': '100px' }}>
                    <Row>
                        <Col sm={10} md={10} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                            <div className="main-header">
                                <h2 className="title">Store</h2>
                            </div>
                        </Col>
                    </Row>

                    <Row>
                        <Col sm={10} md={10} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                            <section className="tutorial-modules">
                                <h3 className="category-title">Tutorials</h3>
                                {this.prepareTutorialModuleItems()}
                            </section>
                            <section className="foundation-modules">
                                <h3 className="category-title">Foundation Topics</h3>
                                {this.prepareFoundationalModuleItems()}
                            </section>

                            {this.purchaseModal()}
                            {this.purchaseFreeModal()}
                        </Col>
                    </Row>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/containers/workerStore.js